/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ phone: NonNullable<unknown> }} Messages_Send_To_NumberInputs */

const en_messages_send_to_number = /** @type {(inputs: Messages_Send_To_NumberInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Send to ${i?.phone}`)
};

const he_messages_send_to_number = /** @type {(inputs: Messages_Send_To_NumberInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`שלח אל ${i?.phone}`)
};

/**
* | output |
* | --- |
* | "Send to {phone}" |
*
* @param {Messages_Send_To_NumberInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const messages_send_to_number = /** @type {((inputs: Messages_Send_To_NumberInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Messages_Send_To_NumberInputs, { locale?: "en" | "he" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_messages_send_to_number(inputs)
	return he_messages_send_to_number(inputs)
});